import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Toolbar from "@mui/material/Toolbar";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialBox from "../../../../components/MaterialBox";
import {
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "../../../../context";
import { navbarContainer, navbar, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import { Avatar, Box, styled, Typography } from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import UserDetailsContext from "../../../../context/auth";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import BASEURL from "../../../../pages/Utils/Baseurl";
import Swal from "sweetalert2";
import moment from "moment";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import assestsConfig from "../../../../config/assestsConfig";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});
function DashboardNavbar({ absolute, light, isMini }) {
  const { user } = useContext(UserDetailsContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const route = useLocation().pathname.split("/").slice(1);
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar } = controller;

  const [navbarType, setNavbarType] = useState();

  const [openMenu, setOpenMenu] = useState(false);

  const open = Boolean(openMenu);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [attendance, setAttendance] = useState({
    isCheckedIn: false,
    startTime: null,
    elapsedTime: "00:00:00",
    checkoutTime: null,
    checkIn: null,
    time: null,
  });
  
  const [userDetails, setUserDetails] = useState({
    name: "",
    picture: "",
    email: "",
  });

  const [pageState, setPageState] = useState({
    state: "init",
  });

  const [attendanceData, setAttendanceData] = useState([]);

  const [selectedYear] = useState(new Date().getFullYear());

  const [selectedMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    const getUser = () => {

      const userDetails = sessionStorage.getItem("user");

      const getDetails = JSON.parse(userDetails);

      setUserDetails({
        name: user[0]?.first_name || getDetails.first_name || "Admin",

        email: user?.email || getDetails.email || "",

        picture: user?.picture || getDetails.picture || "",
      });
      setPageState({

        state: "default",

      });
    };
    getUser();

    fetchAttendanceData();

  }, []);
  // Restore attendance data on load
  useEffect(() => {

    const isCheckedIn = localStorage.getItem("isCheckedIn") === "true";

    const startTime = localStorage.getItem("startTime");

    const checkoutTime = localStorage.getItem("checkoutTime");

    const elapsedTime = localStorage.getItem("elapsedTime") || "00:00:00";

    updateAttendance({

      isCheckedIn,

      startTime: startTime ? new Date(startTime) : null,

      checkoutTime: checkoutTime || null,

      elapsedTime: elapsedTime || "00:00:00",
    });
  }, []);
  // Reset at 9:30 AM Daily
  useEffect(() => {
    const interval = setInterval(() => {

      const now = new Date();

      const today = now.toISOString().split("T")[0];

      const lastReset = localStorage.getItem("lastResetDate");

      if (
        now.getHours() === 9 &&

        now.getMinutes() === 30 &&

        today !== lastReset

      ) {
        // Reset everything
        localStorage.removeItem("startTime");

        localStorage.removeItem("checkoutTime");

        localStorage.removeItem("elapsedTime");

        localStorage.setItem("isCheckedIn", "false");

        localStorage.setItem("lastResetDate", today);

        updateAttendance({
          isCheckedIn: attendance?.isCheckedIn,

          startTime: null,

          elapsedTime: "00:00:00",

          checkoutTime: null,

          checkIn: null,

          time: null,
        });
      }
    }, 60000);

    return () => clearInterval(interval);
  }, []);
  // Save isCheckedIn status persistently
  useEffect(() => {

    localStorage.setItem("isCheckedIn", attendance.isCheckedIn);

  }, [attendance.isCheckedIn]);

  // Real-time working hours timer
  useEffect(() => {
    if (!attendance.time) return;

    const checkInTime = new Date(attendance.time).getTime();

    const updateElapsed = () => {

      const now = Date.now();

      const diff = now - checkInTime;

      if (diff > 0) {

        const hours = Math.floor(diff / 3600000);

        const minutes = Math.floor((diff % 3600000) / 60000);

        const seconds = Math.floor((diff % 60000) / 1000);

        updateAttendance({

          elapsedTime: `${String(hours).padStart(2, "0")}:${String(
            minutes
          ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`,

        });
      }
    };

    updateElapsed();

    const interval = setInterval(updateElapsed, 1000);

    return () => clearInterval(interval);

  }, [attendance.time]);

  useEffect(() => {
    getLatestAttendanceData();
  }, [attendance.isCheckedIn]);


  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);



  const attendanceQuery = `
    query userAttendanceDetails($id: String!) {
      userAttendanceDetails(id: $id) {
        data
        {
        id
        checkIn
        checkOut
        totalWorkingHours
        }
      
      }
    }
  `;
  const fetchAttendanceData = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: attendanceQuery,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setAttendanceData(response.data?.data?.userAttendanceDetails?.data);
    } catch (err) {}
  };
  // Load today's attendance data from API
  const handleCheck = useCallback(async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return;

    const query = `
      query userAttenance($id: String!) {
        todayUserAttendanceDetails(id: $id) {
          checkIn
          checkOut
        }
      }
    `;

    try {
      const res = await axios.post(BASEURL, {
        query,
        variables: { id: user.id },
      });

      const data = res?.data?.data?.todayUserAttendanceDetails?.[0];

      if (data?.checkOut) {
        const formatted = new Date(data.checkOut).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        updateAttendance({
          isCheckedIn: false,
          elapsedTime: localStorage.getItem("elapsedTime") || "00:00:00",
          checkoutTime: formatted,
        });
      } else if (data?.checkIn) {
        updateAttendance({
          isCheckedIn: true,
          time: data.checkIn,
          checkIn: data.checkIn,
        });
      }
    } catch (err) {}
  }, []);
  useEffect(() => {
    handleCheck();
  }, [handleCheck]);
  // Clock-In / Clock-Out Handler
  const handleCheckIn = async () => {
    const now = new Date();
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return;

    const checkInMutation = `
      mutation checkin($id: String!) {
        checkInUpdate(id: $id) {
          checkin { id }
        }
      }
    `;
    const checkOutMutation = `
      mutation checkOut($id: String!) {
        checkOut(id: $id) {
          checkout { id }
        }
      }
    `;

    try {
      if (attendance.isCheckedIn) {
        // 🟥 CLOCK-OUT FLOW
        const start = moment(attendance.startTime);
        const nowTime = moment();

        const duration = moment.duration(nowTime.diff(start));
        const totalWorked = moment
          .utc(duration.asMilliseconds())
          .format("HH:mm:ss"); // ← this always formats correctly

        const formattedCheckout = nowTime.toDate().toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        const res = await axios.post(BASEURL, {
          query: checkOutMutation,
          variables: { id: user.id },
        });

        if (res.data.errors) {
          Swal.fire({ title: res.data.errors[0].message });
          return;
        }

        localStorage.setItem("elapsedTime", totalWorked);
        localStorage.setItem("checkoutTime", formattedCheckout);
        localStorage.setItem("isCheckedIn", "false");
        localStorage.removeItem("startTime");

        updateAttendance({
          isCheckedIn: false,
          startTime: null,
          checkoutTime: formattedCheckout,
          elapsedTime: totalWorked,
        });

        handleCheck();
      } else {
        // ✅ CLOCK-IN FLOW
        const isoTime = now.toISOString();

        const res = await axios.post(BASEURL, {
          query: checkInMutation,
          variables: { id: user.id },
        });

        if (res.data.errors) {
          Swal.fire({ title: res.data.errors[0].message });
          return;
        }

        localStorage.setItem("isCheckedIn", "true");
        localStorage.setItem("startTime", isoTime);
        localStorage.removeItem("checkoutTime");

        updateAttendance({
          isCheckedIn: true,
          startTime: isoTime,
          time: isoTime,
          checkIn: isoTime,
          checkoutTime: null,
          elapsedTime: "00:00:00",
        });

        handleCheck();
      }
    } catch (err) {}
  };

  const getLatestAttendanceData = (data) => {
    const latestData = {};
    data?.forEach((item) => {
      const date = new Date(item.checkIn || item.checkOut)
        .toISOString()
        .slice(0, 10);
      if (
        !latestData[date] ||
        new Date(item.lastUpdate) > new Date(latestData[date].lastUpdate)
      ) {
        latestData[date] = item;
      }
    });
    return Object.values(latestData);
  };
  const filteredAttendanceData = getLatestAttendanceData(attendanceData).filter(
    (item) => {
      const date = new Date(item.checkIn);
      return (
        date.getFullYear() === parseInt(selectedYear) &&
        date.getMonth() + 1 === parseInt(selectedMonth) &&
        item.checkIn &&
        !item.checkOut // Only include entries with checkIn but no checkOut
      );
    }
  );

  const onLogOut = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Logout ?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        signOut();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setOpenMenu(false);
      },
    });
  };
  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  const signOut = () =>{ 
    // Clear all cookies
    const clearAllCookies = () => {
      const cookies = document.cookie.split(";");
      cookies.forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
      });
      console.log("✅ All cookies cleared");
    };

    clearAllCookies();
    console.log("🔴 Logout initiated");
    console.log("Clearing session storage...");
    sessionStorage.clear();
    localStorage.clear();
    console.log("✅ Session storage and local storage cleared");

     if(assestsConfig.company === "Eg")
        {
          console.log("🚀 Redirecting to EG login page...");
          window.location.replace(assestsConfig.logouturl || "https://egtech.in/");
        }
        else
        {
          console.log("🚀 Redirecting to home page...");
          navigate("/")
        }
  }
  const updateAttendance = (updates) =>
    setAttendance((prev) => ({ ...prev, ...updates }));
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={
          <>
            {userDetails.picture ? (
              <Avatar
                alt={userDetails.name}
                src={userDetails.picture}
                sx={{ width: 24, height: 24 }}
              />
            ) : (
              <MaterialAvatar
                size="sm"
                {...stringAvatar(
                  userDetails.name || userDetails.email || "UNNAMED"
                )}
              />
            )}
          </>
        }
        title={userDetails.name || userDetails.email}
      />
      <NotificationItem
        id="logout"
        onClick={onLogOut}
        icon={<LogoutIcon />}
        title={"Logout"}
      />
    </Menu>
  );

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => ({
        ...navbar(theme, { transparentNavbar, absolute, light }),
        boxShadow: theme.palette.mode === "dark" ? 0 : 3, // Optional: Add shadow for non-dark mode
        transition: "all 0.3s ease", // Smooth transition for dynamic state changes
      })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {pageState.state === "default" && (
          <>
            {/* Left Section: Menu Toggle & Breadcrumb */}
            <MaterialBox
              color="inherit"
              mb={{ xs: 1, md: 0 }}
              sx={(theme) => navbarRow(theme, { isMini })}
            >
              <MaterialBox display="flex" alignItems="center">
                {/* Menu Toggle Icon */}
                <Icon
                  fontSize="medium"
                  onClick={handleMiniSidenav}
                  sx={{ cursor: "pointer", marginRight: 2 }}
                >
                  {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                </Icon>

                {/* Breadcrumb Navigation */}
                <MaterialBox ml={1}>
                  <Breadcrumbs
                    icon={<HomeIcon />}
                    title={route[route.length - 1]}
                    route={route}
                    light={light}
                    sx={{ color: theme.palette.text.primary }} // Optional: Adjust breadcrumb text color
                  />
                </MaterialBox>
              </MaterialBox>
            </MaterialBox>

            {/* Right Section: Profile Menu */}
            {isMini ? null : (
              <MaterialBox
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                {/* <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <CustomWidthTooltip
                    title={
                      filteredAttendanceData?.length > 0 ? (
                        <div>
                          {filteredAttendanceData.map((entry, index) => (
                            <div
                              key={index}
                              style={{
                                justifyContent: "center",
                              }}
                            >
                              <div>
                                Date:{" "}
                                {new Date(entry.checkIn).toLocaleDateString()}
                              </div>
                              <div>
                                Check In:{" "}
                                {entry.checkIn &&
                                  new Date(entry.checkIn).toLocaleTimeString()}
                              </div>
                              {entry?.checkOut && (
                                <div>
                                  Check Out:{" "}
                                  {entry.checkOut &&
                                    new Date(
                                      entry.checkOut
                                    ).toLocaleTimeString()}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : null
                    }
                    disableInteractive
                  >
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                      {attendance?.elapsedTime &&
                        attendance?.elapsedTime
                          .split(":")
                          .map((unit, index) => (
                            <span
                              key={index}
                              sx={{
                                perspective: "500px",
                              }}
                            >
                              <MaterialBox
                                sx={{
                                  backgroundColor: "#D1D8BE",
                                  color: "#000",
                                  fontFamily: "Courier New, monospace",
                                  fontSize: "15px",
                                  minWidth: "36px",
                                  padding: "2px 6px",
                                  borderRadius: "6px",
                                  textAlign: "center",
                                  display: "inline",
                                  animation: "flipIn 0.5s ease-in-out",
                                }}
                              >
                                {unit}
                              </MaterialBox>
                            </span>
                          ))}
                    </Box>
                    <style>
                      {`
        @keyframes flipIn {
          0% {
            transform: rotateX(-90deg);
            opacity: 0;
          }
          50% {
            transform: rotateX(10deg);
            opacity: 0.6;
          }
          100% {
            transform: rotateX(0deg);
            opacity: 1;
          }
        }
      `}
                    </style>
                  </CustomWidthTooltip>
                </Typography>
                <Tooltip
                  title={attendance.isCheckedIn ? "Check Out" : "Check In"}
                  disableInteractive
                >
                  <IconButton
                    size="small"
                    sx={{
                      border: "1px solid",
                      borderColor: attendance.isCheckedIn
                        ? "error.main"
                        : "success.main", // outlined border
                      backgroundColor: attendance.isCheckedIn
                        ? "rgba(235, 34, 34, 0.1)" // error.main with 10% opacity
                        : "rgba(51, 158, 56, 0.1)", // success.main with 10% opacity
                      color: attendance.isCheckedIn
                        ? "error.main"
                        : "success.main", // outlined icon color
                      borderRadius: "4px", // rectangular shape
                      padding: "8px 2px",
                      minWidth: "auto",
                      "&:hover": {
                        backgroundColor: attendance.isCheckedIn
                          ? "rgba(235, 34, 34, 0.1)" // error.main with 10% opacity
                          : "rgba(51, 158, 56, 0.1)", // success.main with 10% opacity
                      },
                    }}
                    onClick={handleCheckIn}
                  >
                    {attendance.isCheckedIn ? (
                      <CloseIcon fontSize="small" />
                    ) : (
                      <CheckIcon fontSize="small" />
                    )}
                  </IconButton>
                </Tooltip> */}
                {/* Profile Icon with Menu */}
                <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                  <IconButton
                    onClick={handleOpenMenu}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    sx={{
                      borderRadius: "50%",
                      padding: 0,
                      "&:hover": {
                        backgroundColor: (theme) => theme.palette.action.hover,
                      },
                    }}
                  >
                    <MaterialAvatar
                      alt={userDetails.name}
                      src={userDetails.picture}
                      sx={{ width: 35, height: 35 }}
                    />
                  </IconButton>

                  {/* Profile Menu */}
                  {renderMenu()}
                </MaterialBox>
              </MaterialBox>
            )}
          </>
        )}
      </Toolbar>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
